<template>
  <div :class="b()">
    <component :is="component" :data="data" v-if="component"/>
  </div>
</template>

<script>
    const COMPONENT_NAME = "dynamic-link";

    export default {
        name: COMPONENT_NAME,
        props: ['data', 'type'],
        data() {
            return {
                component: null
            };
        },
        computed: {
            loader() {
                if (!this.type) {
                    return null
                }
                return () => import(`./templates/${this.type}`);
            },
        },
        async mounted() {
            let componentLoader = this.loader();
            let loadResult = await componentLoader;
            this.component = loadResult.default;
        }
    }
</script>

<style lang="scss" scoped>

</style>